
import g from "../globals/variables";

const Footer = (target) => {

  const el = {
    footerNavigations: target.querySelectorAll(".footer__navigation-list"),
  };

  const method = {

    init: () => {
      el.footerNavigations.forEach((nav) => {
        nav.querySelector("h6 a").addEventListener("click", (event) => {
          method.toggleNavigation(event, nav);
        });
      });
    },

    toggleNavigation: (event, navigation) => {
      if (window.innerWidth < g.resolution.m) {
        event.preventDefault();
        navigation.classList.toggle("footer__navigation-list--active");
      }
    },

  };

  method.init();
};

export default Footer;
